import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.REACT_APP_URL_API;

class OdooService {
    getContractsCustomer(cm) {
        return axios.get(
            API_URL + 'haugazel/contracts_customer/' + cm ,
            { headers: authHeader()
            })
            .then(response => {
                if (response.data && !response.data.error) {
                    const  contracts= response.data.contracts;
                    const  customer= response.data.customer;
                    const  messagerecovery= response.data.messagerecovery;
                    const  sumamountdunning= response.data.sumamountdunning;
                    localStorage.setItem("contracts", JSON.stringify(contracts));
                    localStorage.setItem("customer", JSON.stringify(customer));
                    localStorage.setItem("messagerecovery", JSON.stringify(messagerecovery));
                    localStorage.setItem("sumamountdunning", JSON.stringify(sumamountdunning));
                }

                return response.data;
            });

    }

    getContractCustomer(cm, refContract, token) {
        return axios.get(
            API_URL + 'haugazel/contracts_customer/' + cm + '/' + refContract,
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            })
            .then(response => {
                if (response.data) {
                    const  contracts= response.data.contracts;
                    const  customer= response.data.customer;
                    const  messagerecovery= response.data.messagerecovery;
                    const  sumamountdunning= response.data.sumamountdunning;
                    localStorage.setItem("contracts", JSON.stringify(contracts));
                    localStorage.setItem("customer", JSON.stringify(customer));
                    localStorage.setItem("messagerecovery", JSON.stringify(messagerecovery));
                    localStorage.setItem("sumamountdunning", JSON.stringify(sumamountdunning));
                }

                return response.data;
            });

    }

}

export default new OdooService();
